import { render, staticRenderFns } from "./BrandingSettings.vue?vue&type=template&id=8d5a1850"
import script from "./BrandingSettings.vue?vue&type=script&lang=js"
export * from "./BrandingSettings.vue?vue&type=script&lang=js"
import style0 from "./BrandingSettings.vue?vue&type=style&index=0&id=8d5a1850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports